import React from 'react';
import { useSnackbar } from 'notistack';

const withSnackbar = Component => {
  const WithSnackbar = props => {
    const snackbar = useSnackbar();

    return <Component {...props} {...snackbar} />;
  };

  WithSnackbar.displayName = `WithSnackbar(${Component.displayName || Component.name || 'Component'})`;

  return WithSnackbar;
};

export default withSnackbar;
